
// Define types for our authentication context
export interface User {
  id: string;
  email: string;
  username?: string;
  avatar_url?: string;
}

export interface Session {
  user: User | null;
  token: string | null;
}

export interface AuthContextType {
  session: Session | null;
  user: User | null;
  signUp: (email: string, password: string) => Promise<void>;
  signIn: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
  loading: boolean;
  updateProfile: (data: { username?: string, avatar_url?: string }) => Promise<void>;
  setUser?: (user: User | null) => void;
}

export interface AuthFormValues {
  email: string;
  password: string;
  fullName?: string;
}

// Add type for Supabase user conversion
export const mapSupabaseUser = (supabaseUser: any): User => {
  return {
    id: supabaseUser.id,
    email: supabaseUser.email || '',
    username: supabaseUser.user_metadata?.full_name || undefined,
    avatar_url: supabaseUser.user_metadata?.avatar_url || undefined
  };
};
